/**
 * Multi-app redirect query param (`?multiApp=<base62>`).
 *
 * Receiving handoff works the same for every auth UI mode:
 * - OIDC / enterprise SSO only
 * - Classic username+password only
 * - Both
 *
 * `multiApp` always exchanges via `/api/v3/login/sso` into classic session
 * fields (accessToken, refreshToken, …). Each app persists that session with
 * its own store; OIDC-only apps must still accept this classic session when
 * arriving from another Solaris app.
 */
export const MULTI_APP_PARAM = 'multiApp';
